import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() label = '';
  @Input() type = 'primary';
  @Input() class = '';
  @Input() iconImg = '';
  @Input() iconAlt = '';
  @Input() disabled = false;
  @Output() click:EventEmitter<any> = new EventEmitter();
  @Output() enterClick:EventEmitter<any> = new EventEmitter();

  emitClick() {
    this.click.emit();
  }

  emitEnter(event: Event) {
    this.enterClick.emit(event);
  }
}
